import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConsultaPadrao } from "../../../../../components/ConsultaPadrao";
import { model_repeticao_tempo_exercicio } from "../../../../../models";

export const RepeticaoTempoExercicio = forwardRef((props: any, ref) => {
    const [show, setShow] = useState(false);
    const [repeticaoTempo, setRepeticaoTempo] = useState<any>();

    function openModal(_agenda: any) {
        setRepeticaoTempo(_agenda);
        setShow(true);
    }

    function closeModal() {
        setShow(false);
    }

    useImperativeHandle(ref, () => ({
        openModal
    }))

    const columns = [
        { field: 'etapaexercordem', header: 'Ordem' },
        { field: 'exercicio.exercdescricao', header: 'Exercício' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    return (
        repeticaoTempo &&
        <Modal show={show} onHide={closeModal} centered={true} size='xl'>
            <ConsultaPadrao
                model={{
                    ...model_repeticao_tempo_exercicio,
                    api_get: '/etapa/exercicios?etapaid=' + repeticaoTempo?.etapaid,
                    inputs: model_repeticao_tempo_exercicio.inputs.map(input =>
                        input.id === 'etapa.etapaid' ? { ...input, defaultValue: repeticaoTempo?.etapaid } : input
                    )
                }}
                columns={columns}
                scrollHeight='500px'
            />

        </Modal>
    )
})